import { useFormContext } from 'react-hook-form';
import { dsClass } from '../../../common/constants/dsClasses.js';
import { invalidDateMsg, t } from '../../../common/i18n/index.js';
import { DatePicker } from '../../../common/react-hook-form/components/DatePicker.js';
import { SelectRadio } from '../../../common/react-hook-form/components/SelectRadio.js';
import { validateScheduledChangeDate } from '../../../common/utils/dateUtils.js';
import { ScheduleChangeType } from '../subscriptionDetailsUtils.js';
import type { BillingAccountAndUserInfoFormValues } from '../subscriptionDetailsUtils.js';

const SCHEDULED_CHANGE_MAX_DAYS = 30;

interface ScheduledChangeFieldsProps {
  disableFutureDate: boolean;
}

export const ScheduledChangeFields = ({ disableFutureDate }: ScheduledChangeFieldsProps) => {
  const { watch } = useFormContext<BillingAccountAndUserInfoFormValues>();
  const scheduleChangeOption = watch('scheduledChange.change');

  const today = new Date();
  const endDate = new Date();
  endDate.setDate(today.getDate() + SCHEDULED_CHANGE_MAX_DAYS);

  return (
    <>
      <div className={`${dsClass.FONT_STYLE_NORMAL} ${dsClass.FONT_WEIGHT_BOLD}`}>
        {t.JHAG('When will the change be published?')}
      </div>
      <SelectRadio
        name="scheduledChange.change"
        defaultValue={ScheduleChangeType.NOW}
        items={[
          { label: t.DFUR('As soon as possible'), value: ScheduleChangeType.NOW },
          {
            label: t.MYX9('Select date'),
            value: ScheduleChangeType.FUTURE,
            disabled: disableFutureDate,
          },
        ]}
      />
      {scheduleChangeOption === ScheduleChangeType.FUTURE && (
        <DatePicker
          disableAllPastDays={true}
          blockedDates={[new Date()]}
          disableWeekends={false}
          label=""
          name="scheduledChange.date"
          required={true}
          validate={value => validateScheduledChangeDate(value, SCHEDULED_CHANGE_MAX_DAYS, t.ULMQ(invalidDateMsg))}
          visibleRange={[
            [today.getFullYear(), today.getMonth() + 1, today.getDate()],
            [endDate.getFullYear(), endDate.getMonth() + 1, endDate.getDate()],
          ]}
        />
      )}
    </>
  );
};
